//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
import {Permissions} from '@simpleforyou/coaching-shared';
//================= [VUE COMPONENTS] ==========================

export const fileSystemRoutes = [
  {
    path: i18n.global.t('routes.fileSystem'),
    name: Routes.FILE_SYSTEM_LIST,
    component: () => import('@/components/fileSystem/FileSystemList.vue'),
    meta: {
      title: i18n.global.t('titles.fileSystem'),
      active: 'fileSystem',
      roles: [Permissions.ROLE_FILE_SYSTEM_INDEX],
    },
  },
];
